import { ChatHistoryMessage } from '@choco-admin/types';
import React from 'react';

import { ChatHistoryMessageItem } from './ChatHistoryMessageItem';

interface ChatHistoryListProps {
  messages: ChatHistoryMessage[];
}

export const ChatHistoryList: React.FC<ChatHistoryListProps> = ({
  messages,
}) => {
  return (
    <div className="space-y-4">
      {messages.map((message) => (
        <ChatHistoryMessageItem key={message.id} message={message} />
      ))}
    </div>
  );
};
